<template>
	<div class="enum-form">
		<!--select 类型-->
		<Select
			v-model="selectedValue"
			@on-change="changeEnum"
			v-if="type==='select'"
			:disabled="disabled"
			:multiple="multiple"
		>
			<Option value label="--请选择--"></Option>
			<Option
				v-for="item in enums"
				:value="item.sysEnmuDataValue"
				:key="item.sysEnumDataId"
				:label="item.sysEnmuDataKey"
			></Option>
		</Select>
		<!--Radio类型-->
		<RadioGroup
			v-model="selectedValue"
			@on-change="changeEnum"
			v-if="type==='radio'"
			:class="vertical===true? 'ivu-radio-group-vertical':''"
		>
			<Radio
				v-for="item in enums"
				:key="item.sysEnumDataId"
				:label="item.sysEnmuDataKey"
				:disabled="disabled"
			></Radio>
		</RadioGroup>
		<!--checkbox类型-->
		<CheckboxGroup
			v-model="selectedValues"
			@on-change="changeEnum"
			v-if="type==='checkbox'"
			:class="vertical===true? 'enum-checkbox-group-vertical':''"
		>
			<Checkbox
				v-for="item in enums"
				:key="item.sysEnumDataId"
				:label="item.sysEnmuDataKey"
				:disabled="disabled"
			></Checkbox>
		</CheckboxGroup>

		<!--switch类型-->
		<iSwitch
			@on-change="changeEnum"
			v-if="type==='switch'"
			size="large"
			:value="status"
			:disabled="disabled"
		>
			<!--默认第一个值为显示打开时的内容-->
			<span slot="open">{{enums[0].sysEnmuDataKey}}</span>
			<!--默认第二个值为显示关闭时的内容-->
			<span slot="close">{{enums[1].sysEnmuDataKey}}</span>
		</iSwitch>
		<!--single类型-->
		<!--枚举只需配置一个值用于显示,适用于Boolean类型的数据，必须设为默认值，true为选中，false为不选中-->
		<Checkbox
			v-if="type==='single'"
			@on-change="changeEnum"
			v-model="check"
			:disabled="disabled"
		>{{enums[0].sysEnmuDataKey}}</Checkbox>
	</div>
</template>

<script>
	import { oneOf } from "../assist/assist";
	export default {
		name: "enum-form",
		model: {
			prop: "parentValue",
			event: "on-change"
		},
		data() {
			return {
				enums: [], //从枚举列表读出的枚举数据
				selectedValue: "" || [], //选中的数据
				sysEnmuDataKey: "",
				selectedValues: [], //checkbox选中的数据
				status: true, //switch 默认选中
				check: false,
				watchNum: 0
			};
		},
		props: {
			type: {
				validator(value) {
					//自定义验证函数
					return oneOf(value, ["select","radio","checkbox","switch","single"]);
				},
				default: "select"
			},
			vertical: {
				type: Boolean,
				default: false
			},
			disabled: {
				type: Boolean,
				default: false
			},
			multiple: {
				type: Boolean,
				default: false
			},
			enumJsonKey: String,
			parentValue: String || Array
		},
		created() {
			this.$store.commit("initEnums",JSON.parse(window.localStorage.getItem("enums")));
			this.enums = this.$store.state.enums[this.enumJsonKey];
			this.parentValue !== "" && this.parentValue !== null && typeof this.parentValue !== "undefined" ? this.getParentValue(this.parentValue) : this.getDefautValue();
		},

		methods: {
			/**
			 * 数组转字符串
			 */
			toString(arr) {
				let toString = "";
				arr.forEach(item => {
					toString != "" ? (toString += "," + item) : (toString += item);
				});
				return toString;
			},
			/**
			 * 循环赋值
			 */
			filterValue(val, key, value, arr) {
				let data = "";
				if (typeof val === "string") {
					let i = arr.findIndex(item => item[key] === val);
					data = arr[i][value];
				} else {
					for (let i = 0; i < val.length; i++) {
						let j = arr.findIndex(item => item[key] === val[i]);
						data != "" ? (data += "," + arr[j][value]) : (data += arr[j][value]);
					}
				}
				return data;
			},
			/**
			 * 字符串转数组
			 */
			toArray(val, key, value, arr) {
				let newArr = [];
				let data = val.split(",");
				for (let i = 0; i < data.length; i++) {
					let j = arr.findIndex(item => item[key] === data[i]);
					newArr.push(arr[j][value]);
				}
				return newArr;
			},
			/**
			 * 枚举赋值
			 */
			changeEnum(val) {
				switch (this.type) {
					case "select":
						this.multiple
							? this.$emit("on-change", this.toString(val))
							: this.$emit("on-change", val);
						break;
					case "switch":
						val === true
							? this.$emit("on-change", this.enums[0].sysEnmuDataValue)
							: this.$emit("on-change", this.enums[1].sysEnmuDataValue);
						break;
					case "single":
						val === true
							? this.$emit("on-change", "yes")
							: this.$emit("on-change", "no");
						break;
					default:
						let value = this.filterValue(
							val,
							"sysEnmuDataKey",
							"sysEnmuDataValue",
							this.enums
						);
						this.$emit("on-change", value);
				}
			},
			/**
			 * 渲染父页面的值
			 */
			getParentValue(val){
					switch (this.type) {
					case "radio":
						this.selectedValue = this.filterValue(val,"sysEnmuDataValue","sysEnmuDataKey",this.enums);
						break;
					case "checkbox":
						this.selectedValues = this.toArray(val,"sysEnmuDataValue","sysEnmuDataKey",this.enums);
						break;
					case "switch":
						this.enums[0].sysEnmuDataValue === val ? (this.status = true) : (this.status = false);
						break;
					case "single":
						this.parentValue === "yes" ? (this.check = true) : (this.check = false);
						break;
					default:
						this.multiple ?  this.selectedValue = this.parentValue.split(",") : this.selectedValue = this.parentValue;
						break;
				}
			},
			/**
			 * 枚举有默认值的赋值
			 */
			getDefautValue(){
					let data = [];
					for (let i = 0; i < this.enums.length; i++) {
						let item = this.enums[i].isDefaultValue;
						if (item === "1") {
							switch (this.type) {
								case "radio":
									this.selectedValue = this.enums[i].sysEnmuDataKey;
									this.$emit("on-change", this.enums[i].sysEnmuDataValue);
									break;
								case "checkbox":
									this.selectedValues.push(this.enums[i].sysEnmuDataKey);
									data.push(this.enums[i].sysEnmuDataValue);
									this.$emit("on-change", this.toString(data));
									break;
								case "switch":
									this.enums[i].sysEnmuDataKey === this.enums[0].sysEnmuDataKey? (this.status = true) : (this.status = false);
									this.$emit("on-change", this.enums[i].sysEnmuDataValue);
									break;
								case "single":
									this.enums[i].sysEnmuDataValue === "yes"	? (this.check = true) : (this.check = false);
									this.$emit("on-change", this.enums[i].sysEnmuDataValue);
									break;
								default:
									if (this.multiple) {
										this.selectedValue.push(this.enums[i].sysEnmuDataValue);
										this.$emit("on-change",	this.toString(this.selectedValue));
									} else {
										this.selectedValue = this.enums[i].sysEnmuDataValue;
										this.$emit("on-change", this.selectedValue);
									}
									break;
							}
						}
					}
			}

		},
		watch: {
			parentValue: function(val) {
				val !== "" && val !== null && typeof val !== "undefined" ? this.getParentValue(val) : this.getDefautValue();
			}
		}
	};
</script>

<style scoped>
	.enum-checkbox-group-vertical /deep/ .ivu-checkbox-group-item {
		display: block;
	}
	.enum-form >>> .ivu-radio-input,
	.enum-form >>> .ivu-checkbox-input {
		width: 16px;
		height: 16px;
		opacity: 0;
		display: inline-block;
		background: none;
	}
	.enum-form >>> .ivu-radio-inner {
		border: none;
		background: url(../../assets/images/forms/radios.png) no-repeat 0 0;
		background-position-x: 0px;
		background-position-y: 0px;
		height: 16px;
		width: 16px;
		display: -moz-inline-box;
		display: inline-block;
		text-align: center;
		transition: none;
	}
	.enum-form >>> .ivu-radio-inner::after {
		border-color: transparent;
		background-color: transparent;
	}
	.enum-form >>> .ivu-radio-focus {
		box-shadow: 0 0 0 0;
	}
	.enum-form >>> .ivu-radio-checked .ivu-radio-inner {
		background-position: 0 -18px;
	}
	.enum-form >>> .ivu-checkbox-inner {
		background: url(../../assets/images/forms/checkboxes.png) no-repeat 0 0;
		height: 16px;
		width: 16px;
		display: inline-block;
		text-align: center;
	}
	.enum-form >>> .ivu-checkbox-checked:hover .ivu-checkbox-inner {
		border-color: transparent;
	}
	.enum-form >>> .ivu-checkbox-inner::after {
		border-color: transparent;
		background-color: transparent;
	}
	.enum-form >>> .ivu-checkbox-focus {
		box-shadow: 0 0 0 0;
	}
	.enum-form >>> .ivu-checkbox-checked .ivu-checkbox-inner {
		background-position: 0 -17px;
		border-color: transparent;
	}
	.ivu-switch {
		border: none;
		/*background-color: transparent;*/
		background: transparent
			url(../../assets/images/forms/ibutton-slider-default.png) no-repeat scroll
			50% -2px;
		border-radius: 0px;
		transition: none;
		height: 19px;
		line-height: 19px;
	}
	.ivu-switch:focus {
		box-shadow: 0 0 0 0px rgba(45, 140, 240, 0.2);
		outline: 0;
	}
	.enum-form >>> .ivu-switch-inner {
		left: 38px;
	}
	.enum-form >>> .ivu-switch-checked .ivu-switch-inner {
		left: 7px;
	}
	.enum-form >>> .ivu-switch-large.ivu-switch-checked::after {
		left: 29px;
	}
	.ivu-switch::after {
		background: transparent
			url(../../assets/images/forms/ibutton-slider-default.png) no-repeat scroll
			50% -73px;
		border-radius: 0px;
		width: 27px;
		top: 0px;
	}
</style>
